var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-header'),_c('app-core-view'),_c('app-footer'),_c('alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }